export default __webpack_public_path__ + "assets/d2f384f0349304fcae10586576dda901.svg";